<template>
  <div class="container h-100 d-flex justify-content-center align-items-center flex-grow-1">
      <div class="d-flex justify-content-center align-items-center w-100">
        <div class="box mt-4">
            <h1 class="mt-5">OOYYO data</h1>
            <div class="row w-100 mb-4">
                <div class="col-6">
                    <router-link to="prediction" class="btn btn-lg btn-primary text-uppercase d-block w-100">Prediction</router-link>
                </div>
                <div class="col-6">
                    <router-link to="reports" class="btn btn-lg btn-success text-uppercase d-block w-100">Reports</router-link>
                </div>
            </div>
            <div class="row text-center">
                <router-link to="about-ai" class="mt-3 text-white">About AI</router-link>
            </div>
        </div>
      </div>
      
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

    .box {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 10rem;
        width: 500px;

        h1 {
            color: #ddd;
            margin-bottom: 24px;
        }
    }

</style>